import { render, staticRenderFns } from "./DawnwoodSuite.vue?vue&type=template&id=0f9ced3c&scoped=true"
import script from "./DawnwoodSuite.vue?vue&type=script&lang=js"
export * from "./DawnwoodSuite.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/roomdetail.css?vue&type=style&index=0&id=0f9ced3c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9ced3c",
  null
  
)

export default component.exports